import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Pill = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '3px 10px',
  borderRadius: '999px',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: 1.4,
  color,
  backgroundColor: `${color}1A`,
  '&::before': {
    content: '""',
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    backgroundColor: color,
  },
}));
